// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"LoadingSpinner_backdrop__qfkL5"};